import module from 'viaticos/module.js'

const namespaces = {
  'cfdi': 'http://www.sat.gob.mx/cfd/3',
  'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
  'tfd': 'http://www.sat.gob.mx/TimbreFiscalDigital',
}
const nsResolver = (prefix) => namespaces[prefix] || null
const leyendas = {
  'I': 'Ingreso',
  'E': 'Egreso',
  'P': 'Pago',
  'N': 'Nómina',
  'T': 'Traslado',
}

export class ViaticosViaticoDevolucionesAgregarDecodificarService {
  constructor ($q) {
    this.$q = $q
  }

  leer (xml) {
    if (!xml) return this.$q.reject('Error: No se encontró un archivo XML')

    return this.$q((resolve, reject) => {
      const reader = new FileReader()
      reader.onerror = () => (reject('Error: No se pudo leer el archivo XML'))
      reader.onload = (event) => {
        const xml = event.target.result
        const parser = new DOMParser()
        const dom = parser.parseFromString(xml, 'application/xml')
        resolve(dom)
      }
      reader.readAsText(xml)
    })
  }

  parse (operadora_rfc, xml, pdf) {
    const result = {
      data: null,
      xml: xml,
      pdf: pdf,
      errores: 0,
      advertencias: 0,
      mensajes: [],
    }

    return this.leer(xml)
      .then((xmlDocument) => {
        try {
          const data = {
            receptor_rfc: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Receptor/@Rfc', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            receptor_nombre: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Receptor/@Nombre', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            emisor_rfc: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Emisor/@Rfc', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            emisor_nombre: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Emisor/@Nombre', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            subtotal: xmlDocument.evaluate('/cfdi:Comprobante/@SubTotal', xmlDocument, nsResolver, XPathResult.NUMBER_TYPE).numberValue,
            total_impuestos_trasladados: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Impuestos/@TotalImpuestosTrasladados', xmlDocument, nsResolver, XPathResult.NUMBER_TYPE).numberValue || 0,
            total_impuestos_retenidos: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Impuestos/@TotalImpuestosretenidos', xmlDocument, nsResolver, XPathResult.NUMBER_TYPE).numberValue || 0,
            total: xmlDocument.evaluate('/cfdi:Comprobante/@Total', xmlDocument, nsResolver, XPathResult.NUMBER_TYPE).numberValue,
            moneda: xmlDocument.evaluate('/cfdi:Comprobante/@Moneda', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            id_moneda: 1, //undefined, todo: poner en undefined despues de pruebas
            tipo_cambio: xmlDocument.evaluate('/cfdi:Comprobante/@TipoCambio', xmlDocument, nsResolver, XPathResult.NUMBER_TYPE).numberValue,
            tipo_comprobante: xmlDocument.evaluate('/cfdi:Comprobante/@TipoDeComprobante', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            id_categoria: '072', //undefined, todo: poner en undefined despues de pruebas
            tipo_gasto: 'No especificado',
            notas: '',
            fecha: new Date(xmlDocument.evaluate('/cfdi:Comprobante/@Fecha', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue),
            serie: xmlDocument.evaluate('/cfdi:Comprobante/@Serie', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue || '',
            folio: xmlDocument.evaluate('/cfdi:Comprobante/@Folio', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue || '',
            uuid: xmlDocument.evaluate('/cfdi:Comprobante/cfdi:Complemento/tfd:TimbreFiscalDigital/@UUID', xmlDocument, nsResolver, XPathResult.STRING_TYPE).stringValue,
            deducible: true,
          }

          if (data.tipo_comprobante !== 'I' && data.tipo_comprobante !== 'E') {
            result.mensajes.push({
              mensaje: 'El tipo de comprobante de ' + leyendas[data.tipo_comprobante] + ' NO es válido como comprobante de gasto.',
              estatus: 3,
            })
            result.errores += 1
          }

          /*if (data.receptor_rfc !== operadora_rfc) {
            result.mensajes.push({
              mensaje: 'El comprobante NO es emitido para la operadora con RFC: ' + operadora_rfc + '.',
              estatus: 3,
            })
            result.errores += 1
          }*/

          if (data.subtotal === 0) {
            result.mensajes.push({
              mensaje: 'El subtotal del comprobante NO es mayor a 0.',
              estatus: 3,
            })
            result.errores += 1
          }

          if (data.total === 0) {
            result.mensajes.push({
              mensaje: 'El total del comprobante NO es mayor a 0.',
              estatus: 3,
            })
            result.errores += 1
          }

          if (!result.errores) {
            result.mensajes = null
            result.data = data
          }

          return result
        } catch (e) {
          throw new Error('No se pudo decodificar el archivo')
        }
      })
      .catch((error) => {
        result.errores = 1
        result.mensajes.push({mensaje: error, estatus: 3})
        return result
      })
  }
}

module.service('ViaticosViaticoDevolucionesAgregarDecodificarService', ViaticosViaticoDevolucionesAgregarDecodificarService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Devoluciones/Agregar/Decodificar.js